export enum DiagnosticJobType {
  JOB_TYPE_CONTENT_DISCREPANCIES
}